







































import mixins from 'vue-typed-mixins'
import DefaultButton from '@/builder/sections/section/components/DefaultButton.vue'
import Section from '@/builder/sections/mixins/Section'
export default mixins(Section).extend({
  name: 'Background2',
  components: { DefaultButton }
})
